module.exports = __webpack_public_path__ + "img/green-tensor.d79dcbfb.png";